var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleButtonGroup as MuiToggleButtons, ToggleButton as MuiToggleButton } from '@mui/material';
import useFormatOptions from '../../hooks/useFormatOptions';
import Tooltip from '../Tooltip';
export default function ToggleSwitch(props) {
    var value = props.value, onChange = props.onChange, options = props.options;
    var formattedOptions = useFormatOptions(options);
    var onToggleChange = function (e, newValue) {
        if (!newValue || newValue === value)
            return;
        onChange(newValue);
    };
    return (_jsx(MuiToggleButtons, __assign({ exclusive: true, value: value, onChange: onToggleChange }, { children: formattedOptions.map(function (option) { return (_jsx(Tooltip, __assign({ delay: 1000, title: option.label, placement: "top" }, { children: _jsx(MuiToggleButton, __assign({ disableRipple: true, value: option.value, className: "toggle-switch-theme-celes" }, { children: option.icon })) }), option.value)); }) })));
}
